import Phaser from "phaser";

/** Boot: generates placeholder textures so we don't depend on art assets yet. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: "BootScene" });
  }

  preload(): void {
    // Generated 1×1 textures — we tint and scale these in scenes.
    this.makeRectTexture("px", 0xffffff);
    this.makeRectTexture("tower", 0x4cc9f0, 32);
    this.makeRectTexture("enemy", 0xff6b6b, 24);
    this.makeRectTexture("projectile", 0xfff066, 6);
  }

  create(): void {
    this.scene.start("MenuScene");
  }

  private makeRectTexture(key: string, color: number, size = 1): void {
    const g = this.add.graphics({ x: 0, y: 0 });
    g.fillStyle(color, 1);
    g.fillRect(0, 0, size, size);
    g.generateTexture(key, size, size);
    g.destroy();
  }
}
